export default "__VITE_ASSET__BtLLaoAo__"